'use es6';

import Loadable from 'UIComponents/decorators/Loadable';
export const AsyncMon491FeatureModal = Loadable({
  loader: () => import(
  /* webpackChunkName: "mon491-feature-modal" */
  './FeatureModalContainer'),
  LoadingComponent: () => null
});